<template>
  <div class="stats is-margin-top">

    <section>
      <div class='container is-margin-top'>

        <h1 class="title">Отчеты</h1>

        <div class="columns box is-margin-top">
          <div class='column'>
            <b-field label="От">
              <b-datepicker v-model='date_from' placeholder='Выберите дату' />
            </b-field>
            <b-field label="До">
              <b-datepicker v-model='date_due' placeholder='Выберите дату' />
            </b-field>
            <b-field label="Тип отчета">
              <b-select v-model='report_type' placeholder="Выберите тип отчета">
                <option
                  v-for="option in report_types"
                  :value="option.type"
                  :key="option.type">
                  {{ option.label }}
                </option>
              </b-select>
            </b-field>
          </div>
          <div class='column box'>
            <button class="button is-fullwidth is-small-margin-top is-info" @click='show_reports'>Подготовить</button>
            <button class="button is-fullwidth is-small-margin-top" disabled>Печать \ Сохранить в pdf</button>
            <button class="button is-fullwidth is-small-margin-top" disabled>Скачать данные</button>
          </div>
        </div>

        <div v-if='state === "stats"' class='container is-margin-top myDivToPrint'>
          <div class='is-margin-top-20'>
            <vue-frappe 
              id="users_chart"
              :labels='charts_data.labels' 
              title='Пользователи' 
              type='axis-mixed' 
              :height='300' 
              :dataSets="[charts_data.new_users, charts_data.returning_users]"
              :barOptions="{stacked: 1}"
              :tooltipOptions="{formatTooltipY: d => d + ''}">
            </vue-frappe>
          </div>

        
          <div class='is-margin-top-20'>
            <vue-frappe 
              id="money_chart"
              :labels='charts_data.labels' 
              title='Оборот ладушек' 
              type='axis-mixed' 
              :height='300' 
              :dataSets="[charts_data.earnings, charts_data.spendings]"
              :barOptions="{stacked: 1}"
              :tooltipOptions="{formatTooltipY: d => d + ''}">
            </vue-frappe>
          </div>


          <div class='is-margin-top-20'>
            <vue-frappe 
              id="tests_chart"
              :labels='charts_data.labels' 
              title='Тесты' 
              type='axis-mixed' 
              :height='300' 
              :dataSets="[charts_data.test_passed, charts_data.test_tries]"
              :barOptions="{stacked: 1}"
              :tooltipOptions="{formatTooltipY: d => d + ''}">
            </vue-frappe>
          </div>

          <div class='is-margin-top-20'>
            <vue-frappe 
              id="rents_chart"
              :labels='charts_data.labels' 
              title='Развлечения, аренда' 
              type='axis-mixed' 
              :height='300' 
              :dataSets="[charts_data.vgm_rents, charts_data.car_electro_rents, charts_data.car_manual_rents]"
              :barOptions="{stacked: 1}"
              :tooltipOptions="{formatTooltipY: d => d + ''}">
            </vue-frappe>
          </div>

          <div class='is-margin-top-20'>
            <vue-frappe 
              id="spendings_chart"
              :labels='charts_data.labels' 
              title='Развлечения, затраты ладушек' 
              type='axis-mixed' 
              :height='300' 
              :dataSets="[charts_data.vgm_spendings, charts_data.car_electro_spendings, charts_data.car_manual_spendings]"
              :barOptions="{stacked: 1}"
              :tooltipOptions="{formatTooltipY: d => d + ''}">
            </vue-frappe>
          </div>


        </div>

        <div v-if='state === "aggregated"' class='container is-margin-top myDivToPrint'>
          
          <div class='is-margin-top-20'>
            <vue-frappe 
              id="a_users_chart"
              :labels="aggregated_chart.users.labels" 
              title='Посещения' 
              type='percentage' 
              :height='130' 
              :barOptions='barOptions'
              :dataSets="[aggregated_chart.users.new_users]"
              :tooltipOptions="{formatTooltipY: d => d + ''}">
            </vue-frappe>
          </div>

          <div class='is-margin-top-20'>
            <vue-frappe 
              id="a_spendings_chart"
              :labels="['Машины', 'Игровые автоматы']" 
              title='Затраты ладушек' 
              type='percentage' 
              :height='130' 
              :barOptions='barOptions'
              :dataSets="[aggregated_chart.spendings]"
              :tooltipOptions="{formatTooltipY: d => d + ''}">
            </vue-frappe>
          </div>

          <div class='box'>
            <div style='height: 100px'>Тесты</div>
            <div class='packed-top'>
              <vue-frappe 
                id="a_tests_chart"
                :labels="aggregated_chart.tests.labels" 
                title='Сводная статистика' 
                type='percentage' 
                :height='130' 
                :barOptions='barOptions' 
                :dataSets="[aggregated_chart.tests.tries]"
                :tooltipOptions="{formatTooltipY: d => d + ''}">
              </vue-frappe>
            </div>

            <div class='packed-top' v-for='test in aggregated_chart.tests.tests' key='id'>
              <vue-frappe 
                :id="'a_tests_chart_' + test.id" 
                :labels="aggregated_chart.tests.labels" 
                :title='test.title' 
                type='percentage' 
                :height='130' 
                :barOptions='barOptions'
                :dataSets="[test.data]"
                :tooltipOptions="{formatTooltipY: d => d + ''}">
              </vue-frappe>
            </div>
          </div>

          <div class='box is-margin-top-20'>
            <div style='height: 50px'>Машины</div>
            <div class='is-margin-top-20'>
              <vue-frappe 
                id="a_cars_spendings_chart"
                :labels="aggregated_chart.cars.car_types.labels" 
                :title='aggregated_chart.cars.car_types.name' 
                type='percentage' 
                :height='130' 
                :barOptions='barOptions'
                :dataSets="[aggregated_chart.cars.car_types]"
                :tooltipOptions="{formatTooltipY: d => d + ''}">
              </vue-frappe>
            </div>
          </div>

          <div class='box is-margin-top-20'>
            <div style='height: 50px'>Игровые аппараты:</div>
            <ul>
              <li v-for='vgm in Object.keys(aggregated_chart.vgms.raw)'>
                <b>{{ vgm }}</b> - Потрачено <b>{{ aggregated_chart.vgms.raw[vgm].spendings }}</b> ладушек на <b>{{ aggregated_chart.vgms.raw[vgm].rents }}</b> аренд.  
              </li>
            </ul>
          </div>


        </div>

      </div>

      <div class='is-margin-top'>
      </div>

      <div style='height: 100px'>
      </div>

    </section>

  </div>
</template>

<script>
  export default {
    name: 'stats',
    data () {
      this.$parent.active_tab = 'stats'
      return {
        state: 'idle',
        barOptions: {height: 12, depth: 3},
        date_from: new Date(),
        date_due: new Date(),
        report_type: 'daily',
        reports: [],
        data_loading: false,
        data_ready: false,
        report_types: [{type: 'daily', label: 'Ежедневный'}, {type: 'monthly', label: 'Ежемесячный'}, {type: 'aggregated', label: 'Общий'}],
        activeTab: 0,
        empty_charts_data: {
          labels: [],
          new_users: {name: 'Новые', chartType: 'bar', values: []},
          returning_users: {name: 'Рекуррентные', chartType: 'bar', values: []},
          earnings: {name: 'Заработано', chartType: 'bar', values: []},
          spendings: {name: 'Потрачено', chartType: 'bar', values: []},
          test_tries: {name: 'Попыток', chartType: 'bar', values: []},
          test_passed: {name: 'Пройдено', chartType: 'bar', values: []},
          vgm_rents: {name: 'Игровые автом.', chartType: 'bar', values: []},
          vgm_spendings: {name: 'Игровые автом.', chartType: 'bar', values: []},
          car_electro_rents: {name: 'Электрокар', chartType: 'bar', values: []},
          car_electro_spendings: {name: 'Электрокар', chartType: 'bar', values: []},
          car_manual_rents: {name: 'Педали', chartType: 'bar', values: []},
          car_manual_spendings: {name: 'Педали', chartType: 'bar', values: []}
        },
        aggregated_chart: {},
        empty_aggregated_chart: {
          users: {
            labels: ['Новых', 'Рекуррентных'],
            new_users: {name: 'Новые', chartType: 'bar', values: [0, 0]},
            returning_users: {name: 'Рекуррентные', chartType: 'bar', values: [0, 0]}
          },
          tests: {
            labels: ['Пройдено', 'Не пройдено'],
            tries: {name: 'Попыток', chartType: 'bar', values: [0, 0]},
            passed: {name: 'Пройдено', chartType: 'bar', values: [0, 0]},
            tests: []
          },
          cars: {
          },
          vgms: {
            labels: [],
            data: []
          }
        },
        charts_data: {}
      }
    },
    methods: {
      show_reports: function () {
        console.log(this.report_type, this.date_from.getTime(), this.date_due.getTime())
        var t = this
        t.data_loading = true
        t.data_ready = false
        t.state = 'idle'
        var form = JSON.stringify({method: 'admin_get_reports', params: {report_type: this.report_type, date_from: this.date_from.getTime(), date_due: this.date_due.getTime()}})
        window.$.post(window.gw + 'api/statistics', {data: form}, function (r) {
          var d = JSON.parse(r)
          if (d.result === 'ok') {
            t.reports = d.params.reports
            console.log(t.reports)
            t.prepare_charts_data()
          }
        })
      },
      prepare_charts_data: function () {
        var t = this
        t.data_loading = false
        console.log(t.reports[0].report_type)
        if (t.reports[0].report_type !== 'aggregated') {
          t.charts_data = JSON.parse(JSON.stringify(t.empty_charts_data))
          t.reports.forEach(function (report) {
            var date = new Date(report.date)
            t.charts_data.labels.push(date.toLocaleDateString())
            t.charts_data.new_users.values.push(report.report.new_users)
            t.charts_data.returning_users.values.push(report.report.returning_users)

            t.charts_data.earnings.values.push(report.report.total_earnings)
            t.charts_data.spendings.values.push(report.report.total_spendings)

            t.charts_data.test_tries.values.push(report.report.tests.tries)
            t.charts_data.test_passed.values.push(report.report.tests.passed)

            t.charts_data.vgm_rents.values.push(report.report.vgms.rents)
            t.charts_data.vgm_spendings.values.push(report.report.vgms.spendings)

            t.charts_data.car_electro_rents.values.push(report.report.cars.electro.rents)
            t.charts_data.car_electro_spendings.values.push(report.report.cars.electro.spendings)

            t.charts_data.car_manual_rents.values.push(report.report.cars.electro.rents)
            t.charts_data.car_manual_spendings.values.push(report.report.cars.manual.spendings)
          })
          console.log(t.charts_data)
          t.data_ready = true
          t.state = 'stats'
        }
        if (t.reports[0].report_type === 'aggregated') {
          var r = t.reports[0].report
          t.aggregated_chart = JSON.parse(JSON.stringify(t.empty_aggregated_chart))
          var c = t.aggregated_chart

          c.users.new_users.values = [r.new_users, r.returning_users]

          c.tests.tries.values = [r.tests.passed, r.tests.tries - r.tests.passed]

          Object.keys(r.tests.tests).map(function (key, id) {
            var test = {id: id, title: key, data: {name: key, chartType: 'bar', values: [r.tests.tests[key].passed, r.tests.tests[key].tries - r.tests.tests[key].passed]}}
            c.tests.tests.push(test)
            console.log(id)
          })

          c.vgms.rents = r.vgms.rents
          c.vgms.spendings = r.vgms.spendings

          c.cars.rents = r.cars.rents
          c.cars.spendings = r.cars.spendings

          c.spendings = {name: 'Затраты ладушек', values: [r.cars.spendings, r.vgms.spendings]}

          c.cars.car_types = {name: 'Затраты ладушек на машины', labels: ['Электро', 'Вело'], values: [r.cars.electro.spendings, r.cars.manual.spendings]}

          c.vgms.raw = r.vgms.vgms

          t.data_ready = true
          t.state = 'aggregated'
        }
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
  .is-margin-top {
    margin-top: 20px
  }

  .is-margin-top-20 {
    margin-top: 40px;
    padding: 10px;
  }

  .is-small-margin-top {
    margin-top: 10px;
  }

  .graph-svg-tip.comparison .title {
    color: #fff !important;
  }

  .chart-container .title {
    font-size: 1.2em;
  }

  .packed-top {
    margin-top: -40px;
  }

</style>


// WEBPACK FOOTER //
// src/components/Stats.vue